import React, { useContext, useState } from 'react'
import { FormMoughataaContext, ShowMoughataaContext } from './types'
import { Timeout } from '../../functions/functions'
import ButtonElement from '../../HtmlComponents/ButtonElement'
import InputsMoughataa from './forms/InputsMoughataa'
import { useDispatch } from 'react-redux'
import { AddMoughataaApi } from '../../redux/moughataas/moughataaApiCalls'
import ShowErrorMsg from '../../HtmlComponents/ShowErrorMsg'

interface props {
  modal: boolean,
  toggle: any
}

const CreateMoughataa:React.FC <props> = ({ modal, toggle }) => {
  const [name, setName] = useState("")
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<string[]>([])
  
  const { setShowSuccessMsg } = useContext(ShowMoughataaContext)

  const dispatch: any = useDispatch()

  const handleSubmit = async (e: any) => {
    e.preventDefault()
    try {
      const response: any = await dispatch(AddMoughataaApi({ name }))
      if(response === true) {
        toggle()
        // show success Msg
        setShowSuccessMsg(true)
        setTimeout(() => setShowSuccessMsg(false), Timeout) 
      } else {
        setErrors(response)
      }

      setLoading(true)
    } finally {
      setLoading(false)
    }
  }

  return (
    <FormMoughataaContext.Provider value={{
      name, setName,
    }}>
      {modal && (
        <>
          <div className="fixed inset-0 z-10 overflow-y-auto">
            <div
              className="fixed inset-0 w-full h-full bg-black opacity-40"
              onClick={toggle}
            ></div>
            <div className="flex items-center min-h-screen px-4 py-8">
              <div className="relative w-full max-w-lg p-4 mx-auto bg-white rounded-md shadow-lg">
                <div className="mt-3">
                  {/* Start Modal Body */}
                  <form
                    className="mt-2 sm:ml-4 sm:text-left"
                    onSubmit={handleSubmit}
                  >
                    <ShowErrorMsg errors={errors} setErrors={setErrors}/>
                    <InputsMoughataa />
                    <ButtonElement loading={loading} typeBtn='Ajouter' toggle={toggle}/>
                  </form>
                  {/* End Modal Body */}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </FormMoughataaContext.Provider>
  )
}

export default CreateMoughataa